import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import logo from "../../../assets/images/logo.png"
import Ellipse from "../../../assets/images/Ellipse.png"
import { useState } from "react";

function SignupLeftSideCard() {
    const [activeStep, setActiveStep] = useState(1);
    const testimonials = [
        {
            name: "Sarah Mitchell",
            position: "CFO Global Finance Corp",
            image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop",
        },
        {
            name: "John David",
            position: "CEO, Tech Innovators",
            image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop",
        },
        {
            name: "Michael Chen",
            position: "Marketing Head at Creative Solutions",
            image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop",
        },
    ];


    const steps = [
        { id: 1, title: "DEFINE", desc: "Define your company (ticker or name), categories (operating metrics), time frame and units of measurement." },
        { id: 2, title: "STORE & STANDARDIZE", desc: "Centralize your data and ensure consistency across teammates - everyone works from the same definitions and understanding." },
        { id: 3, title: "PULL INTO EXCEL", desc: "Use a simple formula to retrieve live, structured data instantly into Excel to run analysis, comps, valuation, benchmarking, reporting ,etc." }
    ];

    return (
        <div className="relative h-full w-full bg-[#0A0F1C] flex items-center font-inter overflow-hidden rounded-md">
            <div className="w-full h-full flex px-[35px] py-[35px] sm:p-6 md:px-[35px] md:py-[35px] lg:px-[35px] lg:py-[35px]">
                <div className="flex flex-col justify-center items-start w-full h-full bg-transparent">
                    <img
                        src={Ellipse}
                        alt="Background Graphic"
                        className="absolute top-0 left-0 w-40 sm:w-56 md:w-64 lg:w-72 pointer-events-none select-none"
                    />

                    <div className="w-full max-w-[90%] sm:max-w-[400px] md:max-w-[450px] lg:max-w-[500px] text-white z-10">
                        <div className="flex items-center gap-2 mb-12 ">
                            <img
                                src={logo}
                                alt="Datara Logo"
                                className="w-[140px] sm:w-[170px] md:w-[200px] lg:w-[220px] object-contain invert brightness-0"
                            />
                        </div>

                        <h2 className="font-bold leading-tight mb-[24px] text-[24px] sm:text-[28px] md:text-[32px] lg:text-[35px]">
                            With Datara, you can organize, analyze and extract insights from your financial data - all in once place.
                        </h2>

                        <p className="text-gray-400 !mb-[32px] text-[14px] !text-[#FFFFFF] leading-relaxed">
                            Built for Excel-first professionals in investment banking, asset management, wealth management, strategy and corporate development. No new tools to learn. Define once. Excel forever.
                        </p>
                        {/* <Swiper
                            modules={[Autoplay, Pagination]}
                            autoplay={{ delay: 2000, disableOnInteraction: false }}
                            pagination={{ clickable: true }}
                            loop={true}
                            autoHeight={true}
                            className="w-full max-w-full rounded-[10px] sm:max-w-lg"
                        >
                            {testimonials.map((testimonial) => (
                                <SwiperSlide key={testimonial.name}>
                                    <div className="bg-gradient-to-bl from-[#353c42] via-[#353c42] to-[#2b3035] p-3 sm:p-4 md:p-5 rounded-[10px] shadow-xl border-[1px] border-[#FFFFFF12] shadow-white/10 flex flex-col gap-2">
                                        <p className="block text-[13px] !font-normal sm:text-[14px] mb-[0px] md:text-[15px] text-[#FFFFFF] leading-snug line-clamp-3 sm:line-clamp-4 italic">
                                            Datara has completely transformed how we handle financial reporting.
                                            Its intuitive interface and powerful automation tools save us hours of
                                            manual work every week. We now have real-time visibility into our
                                            financial health, enabling smarter and faster decisions.
                                        </p>
                                        <div className="flex items-center gap-3 sm:gap-3">
                                            <img
                                                src={testimonial.image}
                                                alt="profile"
                                                className="w-[66px] h-[66px] sm:w-[66px] sm:h-[66px] md:w-[66px] md:h-[66px] rounded-lg ring-2 ring-white/20"
                                            />
                                            <div className="flex flex-col inline-block justify-center text-left mt-3">
                                                <span className="font-medium text-[#FFFFFF] text-[15px] sm:text-[16px] md:text-[18px] lg:text-[22px] leading-tight">
                                                    {testimonial.name}
                                                </span>
                                                <p className="text-[#FFFFFF] text-[11px] sm:text-[12px] md:text-[13px] lg:text-[14px] font-normal leading-tight">
                                                    {testimonial.position}
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper> */}

                        <div className="flex gap-[10px] mb-[18px] mt-[26px]">
                            {[1, 2, 3].map((step) => (
                                <button
                                    key={step}
                                    onClick={() => setActiveStep(step)}
                                    className={`flex-1 w-[25px] h-[25px] flex items-center justify-center py-[8px] rounded-full border text-[12px] font-bold tracking-widest transition-all ${activeStep === step
                                        ? "bg-white text-black border-white"
                                        : "bg-transparent text-white border-white/20 hover:border-white/50"
                                        }`}
                                >
                                    STEP {step}
                                </button>
                            ))}
                        </div>

                        <div className="bg-[#222a31] p-3 rounded-[10px] min-h-[118px] overflow-y-auto">
                            <h4 className="text-[#FFFFFF] font-bold text-[16px] mb-1 uppercase tracking-wider">
                                {steps.find(s => s.id === activeStep).title}
                            </h4>
                            <p className="text-[#F4F4F4] !mb-0 font-normal text-[14px] leading-relaxed">
                                {steps.find(s => s.id === activeStep).desc}
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default SignupLeftSideCard;